import noop from 'lodash/noop';
import { createContext, type FunctionComponent, type ReactNode, useContext } from 'react';

type RequestScrollToBottom = () => void;

const ChatMessageListScrollContext = createContext<RequestScrollToBottom>(noop);

export const ChatMessageListScrollProvider: FunctionComponent<{
    readonly children: ReactNode;
    readonly requestScrollToBottom: RequestScrollToBottom;
}> = ({ children, requestScrollToBottom }) => (
    <ChatMessageListScrollContext.Provider value={requestScrollToBottom}>
        {children}
    </ChatMessageListScrollContext.Provider>
);

export const useRequestChatMessageListScrollToBottom = (): RequestScrollToBottom =>
    useContext(ChatMessageListScrollContext);
